module.exports = __webpack_public_path__ + "img/portifolio_maritima.83ddcfaa.jpg";